
const Configuration = {
    BASEURL: process.env.REACT_APP_SERVER_BASE_URL,
    LANDING_SCREEN_SPLINEURL: process.env.REACT_APP_LANDING_SPLINE_URL,
    ROBOT_SPLINEURL: process.env.REACT_APP_ROBOT_SPLINE_URL,
    LINKEDINURL: process.env.REACT_APP_IINVSYS_LINKED_IN_URL,
    FACEBOOKURL: process.env.REACT_APP_IINVSYS_FACEBOOK_URL || "https://www.facebook.com/iinvsys",
    INSTAGRAMURL: process.env.REACT_APP_IINVSYS_INSTAGRAM_URL || "https://www.instagram.com/iinvsys/",
    YOUTUBEURL: process.env.REACT_APP_IINVSYS_YOUTUBE_URL || "https://www.youtube.com/channel/UClvD3P0gf9IZZDPgLc2UVUg",
    THREADSURL: process.env.REACT_APP_IINVSYS_THREADS_URL || "https://www.threads.com/@iinvsys",
    MAILURL: process.env.REACT_APP_IINVSYS_MAIL_URL,
    CHENNAI_LOCATION_URL: process.env.REACT_APP_IINVSYS_CHENNAI_LOCATION,
    PUDUCHERRY_LOCATION_URL: process.env.REACT_APP_IINVSYS_PUDUCHERRY_LOCATION,
    PUDUCHERRY_PRODUCTION_OFFICE_LOCATION_URL: process.env.REACT_APP_PUDUCHERRY_PRODUCTION_OFFICE_LOCATION_URL,
    MUMBAI_LOCATION_URL: process.env.REACT_APP_IINVSYS_MUMBAI_LOCATION || "https://maps.google.com/maps?q=Lotus%20Arc%20One%2C%20Andheri%20West%2C%20Mumbai%20400053&t=&z=15&ie=UTF8&iwloc=&output=embed",
    SEDARAPET_LOCATION_URL: process.env.REACT_APP_IINVSYS_SEDARAPET_LOCATION || "https://maps.google.com/maps?q=13%20Sedarapet%20Main%20Road%2C%20Sedarapet%2C%20Tamil%20Nadu%20605111&t=&z=15&ie=UTF8&iwloc=&output=embed",
    PHONE_NUMBER: '',
    MAIN_ADDRESS: '1st Floor, JK Towers, 100 Feet Road, Puducherry - 605013',
    LINKEDIN_TEXT: "Linkedin/iinvsys",
    OFFICE_TIMINGS: "9.00 - 18.30",
    API_TIMEOUT: 10000,
    API_HEADER: {
        "Content-Type": "application/json",
    },

    FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
    FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    FIREBASE_MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
    FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    S3_URL: process.env.REACT_APP_S3_BASE_URL

}

export default Configuration;